import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import Layout from "./components/Layout";
import ScrollToTop from "./components/ScrollToTop";
import Home from "./pages/Home";
import About from "./pages/About";
import HolidayHomes from "./pages/HolidayHomes";
import Plots from "./pages/Plots";
import TopicPage from "./pages/TopicPage";
import ZentryBuild from "./pages/ZentryBuild";
import Insights from "./pages/Insights";
import InsightArticle from "./pages/InsightArticle";
import ClarityCall from "./pages/ClarityCall";
import Contact from "./pages/Contact";
import FAQ from "./pages/FAQ";
import Admin from "./pages/Admin";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Layout>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/holiday-homes" element={<HolidayHomes />} />
            <Route path="/holiday-homes/:slug" element={<TopicPage kind="holiday" />} />
            <Route path="/plots" element={<Plots />} />
            <Route path="/plots/:slug" element={<TopicPage kind="plot" />} />
            <Route path="/zentry-build" element={<ZentryBuild />} />
            <Route path="/insights" element={<Insights />} />
            <Route path="/insights/:slug" element={<InsightArticle />} />
            <Route path="/clarity-call" element={<ClarityCall />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/faq" element={<FAQ />} />
            <Route path="/admin" element={<Admin />} />
          </Routes>
        </Layout>
        <Toaster position="top-right" richColors />
      </BrowserRouter>
    </div>
  );
}

export default App;
